export const listParagraphPlugin: CKEDITOR.pluginDefinition = {
  init: (editor) => {
    let timeoutId = 0

    editor.on('change', () => {
      window.clearTimeout(timeoutId)

      timeoutId = window.setTimeout(() => {
        // editor.fire('lockSnapshot')

        const listItems = editor.editable().find('ol > li, ul > li')

        for (let index = 0; index < listItems.count(); index++) {
          const listItem = listItems.getItem(index)

          if (
            !listItem.$.firstElementChild ||
            listItem.$.firstElementChild.tagName === 'BR'
          ) {
            const bookmark = editor.getSelection().createBookmarks(true)

            const paragraphEl = document.createElement('p')

            paragraphEl.innerHTML = listItem.$.innerHTML

            listItem.$.innerHTML = paragraphEl.outerHTML

            timeoutId = window.setTimeout(() => {
              editor.getSelection().selectBookmarks(bookmark)
              // @ts-ignore
              editor.undoManager?.update()
              editor.fire('saveSnapshot')
              editor.fire('change')
            })
          }
        }
      })
    })

    editor.on('destroy', () => {
      window.clearTimeout(timeoutId)
    })
  },
}
